import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "./supabase";

function getSessionId(): string {
  const KEY = "sentinel_session_id";
  let id = sessionStorage.getItem(KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(KEY, id);
  }
  return id;
}

function detectDeviceType(ua: string): string {
  if (/tablet|ipad/i.test(ua)) return "tablet";
  if (/mobile|iphone|ipod|android.*mobile|windows phone/i.test(ua)) return "mobile";
  return "desktop";
}

function detectBrowser(ua: string): string {
  if (/edg/i.test(ua)) return "Edge";
  if (/chrome/i.test(ua)) return "Chrome";
  if (/firefox/i.test(ua)) return "Firefox";
  if (/safari/i.test(ua)) return "Safari";
  return "Other";
}

function detectOS(ua: string): string {
  if (/windows/i.test(ua)) return "Windows";
  if (/mac os|macintosh/i.test(ua)) return "macOS";
  if (/android/i.test(ua)) return "Android";
  if (/iphone|ipad|ios/i.test(ua)) return "iOS";
  if (/linux/i.test(ua)) return "Linux";
  return "Other";
}

export function useVisitorTracking(): void {
  const location = useLocation();
  const lastTracked = useRef<string>("");

  useEffect(() => {
    const path = location.pathname;
    if (lastTracked.current === path) return;
    lastTracked.current = path;

    const ua = navigator.userAgent;
    const sessionId = getSessionId();

    supabase.from("sentinel_visitor_tracking").insert({
      session_id: sessionId,
      page_path: path,
      page_title: document.title,
      referrer: document.referrer || null,
      user_agent: ua,
      device_type: detectDeviceType(ua),
      browser: detectBrowser(ua),
      operating_system: detectOS(ua),
    }).then(() => {});
  }, [location.pathname]);
}
